import React, { useState } from 'react';
import { LinkIcon2, PlusIcon } from '../../../svgs/svgs';
import { Icon } from '@iconify/react/dist/iconify.js';
import AddReferenceLinkModal from './AddReferenceLinkModal/AddReferenceLinkModal';
import DeleteReferenceLinkModal from './DeleteReferenceLinkModal/DeleteReferenceLinkModal';
import { getLinkTypeIcon } from '../../../utils/helpers/helpers';

interface AddReferenceLinksProps {
  value?: any[];
  onChange?: any;
  error?: any;
}

export default function AddReferenceLinks({
  value = [],
  onChange,
  error,
}: AddReferenceLinksProps) {
  const [openModal, setOpenModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedLink, setSelectedLink] = useState(null);

  const handleClick = () => {
    setOpenModal(true);
  };

  const handleAddLink = (newLink: any) => {
    const updatedLinks = [...value, newLink];
    onChange?.(updatedLinks);
    setOpenModal(false);
  };

  const handleDeleteLink = (linkToDelete: any) => {
    const updatedLinks = value.filter((link) => link !== linkToDelete);
    onChange?.(updatedLinks);
    setOpenDeleteModal(false);
  };

  return (
    <div>
      <div>
        <div className="w-full flex items-center gap-4 justify-between">
          <div className="w-full flex items-center gap-1">
            <h3 className="text-xs md:text-sm lg:text-sm 3xl:text-base text-input-active-label font-semibold">
              Reference Link(s)
            </h3>
          </div>
          <div className="text-navigation-accent-1 flex items-center gap-1">
            <div className="w-4">
              <PlusIcon />
            </div>
            <p
              onClick={handleClick}
              className="text-xs whitespace-nowrap cursor-pointer hover:underline"
            >
              Add new link
            </p>
          </div>
        </div>
        <p className="text-[14px] mt-1">
          Reference links help your team stay aligned and give Crafter better
          context to your workflow
        </p>
      </div>
      <div
        onClick={() => {
          if (value.length === 0) {
            handleClick();
          }
        }}
        className={`border-0.5 border-gray-3/20 rounded-md bg-modal-input ${value.length > 0 ? 'p-3' : 'p-3'} mt-2 ${error ? 'border-error-2' : ''}`}
      >
        {value.length === 0 ? (
          <div className="flex items-center gap-2 text-input-inactive-placeholder">
            <div className="w-5">
              <LinkIcon2 />
            </div>
            <p className="text-sm">Click to add link</p>
          </div>
        ) : (
          <div className="flex flex-wrap items-center gap-2">
            {value.map((link, index) => (
              <div
                className="flex items-center justify-between rounded-lg gap-4 max-w-60 p-2 bg-[#141414] hover:bg-black-7"
                key={index}
              >
                <div className="flex items-center gap-2">
                  <div>{getLinkTypeIcon(link?.project_link_type)}</div>
                  <p className="truncate text-xs">{link?.project_link_name}</p>
                </div>

                <div className="flex items-center gap-2">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setSelectedLink(link);
                      setOpenDeleteModal(true);
                    }}
                    className="p-0.5 rounded-full transition-colors group disabled:opacity-50"
                  >
                    <Icon
                      icon={'mynaui:edit'}
                      className="w-3 h-3 text-text-primary-body"
                    />
                  </button>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setSelectedLink(link);
                      setOpenDeleteModal(true);
                    }}
                    className="p-0.5 bg-red-500/10 rounded-full border-0.5 border-red-500/10 transition-colors group disabled:opacity-50"
                  >
                    <Icon
                      icon={'qlementine-icons:close-16'}
                      className="w-3 h-3 text-error-2"
                    />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      {error && <p className="text-error-2 text-xs mt-1">{error}</p>}

      <AddReferenceLinkModal
        open={openModal}
        close={() => setOpenModal(false)}
        onAddLink={handleAddLink}
      />
      <DeleteReferenceLinkModal
        open={openDeleteModal}
        close={() => setOpenDeleteModal(false)}
        link={selectedLink}
        onDeleteLink={handleDeleteLink}
      />
    </div>
  );
}
